import { useEffect } from 'react'

const useBlockBackNavigation = () => {
    const handleBackNavigation = (e: PopStateEvent) => {
        const confirmationMessage = '페이지에서 나가면\n작업 사항이 저장되지 않습니다.'
        if (window.confirm(confirmationMessage)) {
            // 사용자가 확인을 누르면 페이지 이동을 허용합니다.
            window.history.back()
        } else {
            // 사용자가 취소를 누르면 페이지 이동을 차단합니다.
            window.history.pushState(null, '', window.location.href)
        }
    }

    useEffect(() => {
        window.history.pushState(null, '', window.location.href)
        window.addEventListener('popstate', handleBackNavigation)

        return () => {
            window.removeEventListener('popstate', handleBackNavigation)
        }
    }, [])
}

export default useBlockBackNavigation
